<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/user' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>用户交易记录</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="transaction" class="demo-form-inline" size="mini">
                    <el-row :span="24">
                        <el-form-item label="客户姓名" :label-width="formLabelWidth" clearable>
                            <el-input v-model="transaction.condition.userName" placeholder="客户姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="交易类型" :label-width="formLabelWidth">
                            <el-select v-model="transaction.condition.transactionType" filterable placeholder="请选择" clearable>
                                <el-option
                                v-for="item in transactionTypes"
                                :key="item.dictCode"
                                :label="item.dictDesc"
                                :value="item.dictCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="交易日期 从" :label-width="formLabelWidth">
                            <el-date-picker
                                v-model="transaction.condition.createTimeFrom"
                                type="date"
                                placeholder="选择日期" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="交易日期 到" :label-width="formLabelWidth">
                            <el-date-picker
                                v-model="transaction.condition.createTimeTo"
                                type="date"
                                placeholder="选择日期" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="操作人" :label-width="formLabelWidth">
                            <el-input v-model="transaction.condition.createByName" placeholder="操作人" clearable></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row :span="24" type="flex" style="justify-content: right;">
                        <el-form-item>
                            <el-button type="info" @click="queryTransaction">查询</el-button>
                            <el-button type="primary" @click="exportTransaction">导出</el-button>
                        </el-form-item>
                    </el-row>
                    
                </el-form>
            </el-col>
        </el-row>
        <!-- <el-row type="flex" style="justify-content: right;" class="button-row">
            <el-button type="primary" @click="createUser">新增</el-button>
        </el-row> -->
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="transactions"
                    size="mini"
                    border
                    :height="tableHeight"
                    v-loading="loading"
                    empty-text="暂无数据"
                    style="width: 100%">
                    <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                    <el-table-column fixed prop="userName" label="客户姓名" width="100"></el-table-column>
                    <el-table-column prop="transactionTypeDesc" label="交易类型" width="100"></el-table-column>
                    <el-table-column prop="amountDesc" label="交易金额" align ="right" width="150"></el-table-column>
                    <el-table-column prop="balanceDesc" label="余额" align ="right" width="150"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column prop="createTime" label="交易时间" width="200"></el-table-column>
                    <el-table-column prop="createByName" label="操作人" width="150"></el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

    </div>
    
</template>

<script>

    export default {
        name:'UserTransaction',
        components: {
        },
        data() {
            // var validatePassword = (rule, value, callback) => {
            //     if(value) {
            //         let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
            //         if(!reg.test(value)) {
            //             callback(new Error("密码必须包含字母和数字，长度为8-20位"));
            //         }
            //     }
            //     callback();
            // };
            return {
                transaction:{
                    condition:{},
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                transactions: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                title:"新增用户",
                transactionTypes:[],
                dialogFormVisible: false,
                formLabelWidth:"120px",
                rules: {
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],
                    amount: [
                        { required: true, message: '请输入充值金额', trigger: 'blur' },
                    ]
                },
                loading: true,
                tableHeight: "",//表格高度
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryTransaction();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTransaction();
            },
            queryTransaction() {
                this.loading = true;
                this.transaction.pageNum = this.currentPage;
                this.transaction.pageSize = this.pageSize;
                this.$axios.post("/transaction/findList",this.transaction).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.transactions = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.loading = false;
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            queryType() {
                let condition = {value:"TRANSACTION_TYPE"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.transactionTypes = res.data.result;
                        }else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }, 
            exportTransaction() {
                this.loading = true;
                this.transaction.pageNum = this.currentPage;
                this.transaction.pageSize = this.pageSize;
                this.$axios.post("/transaction/exportExcel",this.transaction,
                {
                    responseType:"blob"//注意 需要规定后台返回文件流格式
                }).then(
                    res=>{
                        if (res) {
                            let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                            let regFileNames = fileNames.match(/=(.*)$/)[1];
                            const link = document.createElement("a");
                            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                            link.style.display = "none";  //去除a标签的样式
                            link.href = URL.createObjectURL(blob);
                            link.download = decodeURIComponent(regFileNames);
                            document.body.appendChild(link);
                            //模拟点击事件
                            link.click();
                            this.$message.success('导出成功');
                            this.loading = false;
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                        this.loading = false;
                    }
                )
            },
            getTableHeight() {
                let tableH = 350; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
        },
        mounted() {
            this.queryTransaction();
            this.queryType();
        },
        created() {
            this.getTableHeight();
        }
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width:50%;
    }

</style>
